<script lang="ts">
  import PoolBadge from "./PoolBadge.svelte";
  import { shortAddress } from "../../utils";
  import { RefreshCwIcon } from "lucide-svelte";
  let { rank, poolType, poolAddress, pair, trades, wallets, getPoolInfo } =
    $props();
</script>

<tr>
  <td>{rank}</td>
  <td>
    <a
      target="_blank"
      class="link link-primary"
      href={`https://dexscreener.com/solana/${poolAddress}`}
      ><PoolBadge {poolType} /></a
    >
  </td>
  <td>{pair}</td>
  <td>{trades}</td>
  <td>{wallets}</td>
  <td
    ><a
      href={`https://dexscreener.com/solana/${poolAddress}`}
      target="_blank"
      class="link link-primary">{shortAddress(poolAddress)}</a
    ></td
  >
  {#if getPoolInfo}
    <td>
      <button
        class="btn btn-square btn-ghost"
        onclick={() => {
          getPoolInfo();
        }}
      >
        <RefreshCwIcon class="size-4" />
      </button>
    </td>
  {/if}
</tr>
